<script>
	import Product from '../../Stores/Product';
</script>

<style>
	div.zes-notice {
		font-size: .9em;
		color: var(--zes-1-1);
		padding: 1em;
		margin-bottom: 1em;
		border-radius: .5em;
		background: var(--zes-1-4);
	}

	div.zes-notice i {
		color: var(--zes-1-2);
		margin-right: .5em;
	}
</style>

{#if $Product.warnings}
	{#each $Product.warnings as warning}
		<div class="zes-notice">
			<i class="fa-duotone fa-exclamation-triangle"></i> {@html warning.message}
		</div>
	{/each}
{/if}